import * as websocket from 'scoreboard/components/websocket'
import Backbone from 'backbone'
import _ from 'lodash'
import globals from 'scoreboard/components/globals'

let statusByImportId = {}

/**
 * Keeps track of the status of imports.  We'll assume this store is always
 * the most up-to-date since fresh values are pushed from the server.  If we're
 * listening to change events, then even if we read from here and have a
 * slightly stale value, a change event will trigger to make sure we switch to
 * the correct value.
 *
 * Examples:
 *
 * if (valueImportStatus[importId] === 'running') { }
 *
 * valueImportStatus.on('change', ({ id, running, lastImportTime,
 * lastImportStatus }) => {
 *
 * })
 */
let importStatus = {

	subscribe() {
		websocket.latest().then(stompClient => {
			this._subscribe(stompClient)
		})
	},

	_subscribe: function (stompClient) {
		const url = `/topic/database/${globals.databaseId}/imports`
		this.subscription = stompClient.subscribe(url, message => {
			console.dir(message.body)
			let status = JSON.parse(message.body)
			statusByImportId[status.id] = status
			this.trigger('change', status)
		})
	},

	/**
	 * Returns the status for the import with the given ID
	 */
	get(id) {
		return statusByImportId[id]
	},

	unsubscribe() {
		try {
			_.invoke(this.subscription, 'unsubscribe')
		} catch (ignore) {
			// We ignore this because if the websocket connection was already closed
			// this will throw an exception
		} finally {
			delete this.subscription
		}
	}

}

_.extend(importStatus, Backbone.Events)

// If a websocket connection is re-established while user remains on a view
// that depends on import statuses (e.g. admin/imports) then we have to
// re-subscribe once the new connection is successful
Backbone.on('websocket:reconnect', stompClient => {
	importStatus.subscription && importStatus._subscribe(stompClient)
})

export default importStatus

importStatus.__filename__ = 'admin/imports/import-status.js'
